
import React from 'react';
import { TransportationDetails } from '@/types/itinerary';
import { PlaneLanding, PlaneTakeoff } from 'lucide-react';
import JourneyCard from '@/components/travel/JourneyCard';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

// TransportationTab: Manages outbound and return journey details
interface TransportationTabProps {
  outboundDetails: TransportationDetails;
  returnDetails: TransportationDetails;
  handleOutboundChange: (field: keyof TransportationDetails, value: any) => void;
  handleReturnChange: (field: keyof TransportationDetails, value: any) => void;
  saveOutboundDetails: () => void;
  saveReturnDetails: () => void;
  isAuthorized: boolean;
}

const TransportationTab: React.FC<TransportationTabProps> = ({ 
  outboundDetails,
  returnDetails,
  handleOutboundChange,
  handleReturnChange,
  saveOutboundDetails,
  saveReturnDetails,
  isAuthorized
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center">
          <PlaneTakeoff className="h-5 w-5 mr-2 text-glowingTeal" />
          Add Flight Details
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="grid grid-cols-1 gap-6">
          <JourneyCard
            id="outbound-journey-card"
            icon={<PlaneTakeoff className="h-5 w-5 mr-2 text-glowingTeal" />}
            title="Outbound Journey"
            details={outboundDetails}
            handleChange={handleOutboundChange}
            saveDetails={saveOutboundDetails}
            saveButtonText="Save Outbound Details"
            isAuthorized={isAuthorized}
          />
          
          <JourneyCard
            id="return-journey-card"
            icon={<PlaneLanding className="h-5 w-5 mr-2 text-glowingTeal" />}
            title="Return Journey"
            details={returnDetails}
            handleChange={handleReturnChange}
            saveDetails={saveReturnDetails}
            saveButtonText="Save Return Details"
            isAuthorized={isAuthorized}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default TransportationTab;
